
import React from "react";
import { Button } from "@/components/ui/button";

interface StudentsFilterProps {
  sortBy: string;
  sortOrder: "asc" | "desc";
  onSort: (criteria: string) => void;
}

const StudentsFilter = ({ sortBy, sortOrder, onSort }: StudentsFilterProps) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      <Button 
        variant={sortBy === "name" ? "default" : "outline"} 
        size="sm"
        onClick={() => onSort("name")}
      >
        Name {sortBy === "name" && (sortOrder === "asc" ? "↑" : "↓")}
      </Button>
      <Button 
        variant={sortBy === "programCount" ? "default" : "outline"} 
        size="sm"
        onClick={() => onSort("programCount")}
      >
        Programs {sortBy === "programCount" && (sortOrder === "asc" ? "↑" : "↓")}
      </Button>
      <Button 
        variant={sortBy === "date" ? "default" : "outline"} 
        size="sm"
        onClick={() => onSort("date")}
      >
        Date Added {sortBy === "date" && (sortOrder === "asc" ? "↑" : "↓")}
      </Button>
    </div>
  );
};

export default StudentsFilter;
